// @flow
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useOutdatedFollowUps } from '../../hooks/use-outdated-follow-ups';
import { Stack, Typography } from '@mui/material';
import { BlinkingWarningIcon } from '../../../../features';
import { FollowUps } from './follow-ups';
import { useFollowUpsQuery, useSameDayTagId } from '../../../../shared';
import { keycloak } from '@coverright/shared/keycloak';

type Props = {

};
export const SameDayFollowUps = (props: Props) => {
  const sameDayTagId = useSameDayTagId();
  const {agentId} = useParams<{ agentId?: string }>();
  const outdated = useOutdatedFollowUps(agentId)
  const outdatedLength =  outdated?.filter(c => c.tags.some(t => t.tag.id === sameDayTagId)).length;

  return <>
    {!!outdatedLength && <Stack mb={1} direction={'row'} gap={1} alignItems={'center'}>
      <BlinkingWarningIcon />
      <Typography variant={'body2'} color={'error'} fontWeight={500}>
        You have {outdatedLength} Follow Up that are dates prior to today's date. Please review the
        disposition and Next Contact Date
      </Typography>
    </Stack>}
    <FollowUps suffix={'sameDay'}
               title={'Same Day Follow-Ups'}
               includedTagsIds={[sameDayTagId]}
               dataSource={useFollowUpsQuery}
               agent={agentId || keycloak?.tokenParsed?.sub} />
  </>;
};
